import { render, staticRenderFns } from "./GrantResourcePermissions.vue?vue&type=template&id=16ce72f2&"
import script from "./GrantResourcePermissions.vue?vue&type=script&lang=js&"
export * from "./GrantResourcePermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports